import { rest } from 'msw';
import { API_ROOT } from 'configs/env-vars';
import { videoConferenceData } from '__mocks__/mockData/video-conference-data';

const VideoConference = [rest.get(`${API_ROOT}video-conference`, (req, res, ctx) => videoConferenceData)];
export default VideoConference;
